module.exports = __webpack_public_path__ + "img/train.8366b066.svg";